var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('CardForm',{attrs:{"form-data":_vm.formData},on:{"input-card-number":_vm.updateCardNumber,"input-card-name":_vm.updateCardName,"input-card-month":_vm.updateCardMonth,"input-card-year":_vm.updateCardYear,"input-card-cvv":_vm.updateCardCvv}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }